SystemJS.config({
    devConfig: {
        "map": {
            "babel-runtime": "npm:babel-runtime@6.23.0",
            "clean-css": "npm:clean-css@3.4.19",
            "core-js": "npm:core-js@1.2.7",
            "http": "github:jspm/nodelibs-http@0.2.0-alpha",
            "https": "npm:jspm-nodelibs-https@0.2.0",
            "module": "npm:jspm-nodelibs-module@0.2.0",
            "url": "github:jspm/nodelibs-url@0.2.0-alpha",
            "os": "github:jspm/nodelibs-os@0.2.2"
        },
        "packages": {
            "github:jspm/nodelibs-http@0.2.0-alpha": {
                "map": {
                    "http-browserify": "npm:stream-http@2.3.0"
                }
            },
            "npm:commander@2.8.1": {
                "map": {
                    "graceful-readlink": "npm:graceful-readlink@1.0.1"
                }
            },
            "npm:source-map@0.4.4": {
                "map": {
                    "amdefine": "npm:amdefine@1.0.0"
                }
            },
            "npm:stream-http@2.3.0": {
                "map": {
                    "builtin-status-codes": "npm:builtin-status-codes@2.0.0",
                    "xtend": "npm:xtend@4.0.1",
                    "to-arraybuffer": "npm:to-arraybuffer@1.0.1",
                    "inherits": "npm:inherits@2.0.1",
                    "readable-stream": "npm:readable-stream@2.1.4"
                }
            },
            "npm:clean-css@3.4.19": {
                "map": {
                    "commander": "npm:commander@2.8.1",
                    "source-map": "npm:source-map@0.4.4"
                }
            },
            "npm:babel-runtime@6.23.0": {
                "map": {
                    "core-js": "npm:core-js@2.4.1",
                    "regenerator-runtime": "npm:regenerator-runtime@0.10.5"
                }
            },
            "github:jspm/nodelibs-url@0.2.0-alpha": {
                "map": {
                    "url-browserify": "npm:url@0.11.0"
                }
            }
        }
    },
    transpiler: "plugin-babel",
    babelOptions: {
        "optional": [
            "runtime",
            "optimisation.modules.system"
        ]
    },
    map: {
        "babel": "npm:babel-core@6.23.0"
    },
    meta: {
        "./ext/ni_assets/Resources/Public/Modules/lazy_loading/responsiveLazyLoader.js": {
            "deps": [
                "jquery"
            ]
        },
        "ext/ni_assets/Resources/Public/Js/Account.js": {
            "deps": [
                "jquery",
                "ext/ni_assets/Resources/Public/Js/bootstrap.min.js",
                "ext/ni_assets/Resources/Public/Js/Util.js"
            ],
            "globals": {
                "jQuery": "jquery",
                "Util": "ext/ni_assets/Resources/Public/Js/Util.js"
            },
            "exports": "Account",
            "format": "global"
        },
        "ext/ni_assets/Resources/Public/Js/ie8-info.js": {
            "deps": [
                "jquery",
                "ext/ni_assets/Resources/Public/Js/notification.js",
                "ext/ni_assets/Resources/Public/Js/Util.js"
            ],
            "globals": {
                "jQuery": "jquery",
                "Util": "ext/ni_assets/Resources/Public/Js/Util.js"
            }
        },
        "ext/ni_assets/Resources/Public/Libs/flowplayer/flowplayer.js": {
            "exports": "flowplayer",
            "format": "global"
        },
        "ext/ni_assets/Resources/Public/Js/jquery.viewport.js": {
            "deps": [
                "ext/ni_assets/Resources/Public/Libs/flowplayer/hlsjs/hls.light.min.js"
            ]
        },
        "ext/ni_assets/Resources/Public/Libs/flowplayer/hlsjs/hls.light.min.js": {
            "exports": "Hls",
            "format": "global"
        },
        "ext/ni_assets/Resources/Public/Js/notification.js": {
            "deps": [
                "ext/ni_assets/Resources/Public/Css/notification.css!",
                "ext/ni_assets/Resources/Public/Js/modernizr.js"
            ],
            "globals": {
                "jQuery": "jquery"
            }
        },
        "scriptLoad": true
    }
});

SystemJS.config({
    packageConfigPaths: [
        "npm:@*/*.json",
        "npm:*.json",
        "github:*/*.json"
    ],
    map: {
        "angular": "github:angular/bower-angular@1.5.7",
        "assert": "github:jspm/nodelibs-assert@0.2.0-alpha",
        "buffer": "github:jspm/nodelibs-buffer@0.2.0-alpha",
        "child_process": "github:jspm/nodelibs-child_process@0.2.0-alpha",
        "constants": "github:jspm/nodelibs-constants@0.2.0-alpha",
        "crypto": "github:jspm/nodelibs-crypto@0.2.0-alpha",
        "css": "github:systemjs/plugin-css@0.1.23",
        "events": "github:jspm/nodelibs-events@0.2.2",
        "flowplayer": "npm:flowplayer@6.0.5",
        "fs": "github:jspm/nodelibs-fs@0.2.0-alpha",
        "jquery": "npm:jquery@2.2.4",
        "jquery-migrate": "npm:jquery-migrate@1.4.1",
        "magnific-popup": "npm:magnific-popup@1.1.0",
        "path": "github:jspm/nodelibs-path@0.2.3",
        "plugin-babel": "npm:systemjs-plugin-babel@0.0.21",
        "process": "github:jspm/nodelibs-process@0.2.0-alpha",
        "sass": "github:mobilexag/plugin-sass@0.4.6",
        "scss": "github:mobilexag/plugin-sass@0.4.6",
        "stream": "github:jspm/nodelibs-stream@0.2.0-alpha",
        "string_decoder": "github:jspm/nodelibs-string_decoder@0.2.2",
        "util": "github:jspm/nodelibs-util@0.2.0-alpha",
        "vm": "github:jspm/nodelibs-vm@0.2.0-alpha"
    },
    packages: {
        "npm:autoprefixer@6.3.6": {
            "map": {
                "browserslist": "npm:browserslist@1.3.4",
                "caniuse-db": "npm:caniuse-db@1.0.30000488",
                "normalize-range": "npm:normalize-range@0.1.2",
                "num2fraction": "npm:num2fraction@1.2.2",
                "postcss": "npm:postcss@5.0.21",
                "postcss-value-parser": "npm:postcss-value-parser@3.3.0"
            }
        },
        "npm:browserify-aes@1.0.6": {
            "map": {
                "buffer-xor": "npm:buffer-xor@1.0.3",
                "cipher-base": "npm:cipher-base@1.0.2",
                "create-hash": "npm:create-hash@1.1.2",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0",
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:browserify-cipher@1.0.0": {
            "map": {
                "browserify-aes": "npm:browserify-aes@1.0.6",
                "browserify-des": "npm:browserify-des@1.0.0",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0"
            }
        },
        "npm:browserify-des@1.0.0": {
            "map": {
                "cipher-base": "npm:cipher-base@1.0.2",
                "des.js": "npm:des.js@1.0.0",
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:browserify-rsa@4.0.1": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:browserify-sign@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "browserify-rsa": "npm:browserify-rsa@4.0.1",
                "create-hash": "npm:create-hash@1.1.2",
                "create-hmac": "npm:create-hmac@1.1.4",
                "elliptic": "npm:elliptic@6.3.1",
                "inherits": "npm:inherits@2.0.1",
                "parse-asn1": "npm:parse-asn1@5.0.0"
            }
        },
        "npm:cipher-base@1.0.2": {
            "map": {
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:create-ecdh@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "elliptic": "npm:elliptic@6.3.1"
            }
        },
        "npm:create-hash@1.1.2": {
            "map": {
                "cipher-base": "npm:cipher-base@1.0.2",
                "inherits": "npm:inherits@2.0.1",
                "ripemd160": "npm:ripemd160@1.0.1",
                "sha.js": "npm:sha.js@2.4.5"
            }
        },
        "npm:create-hmac@1.1.4": {
            "map": {
                "create-hash": "npm:create-hash@1.1.2",
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:crypto-browserify@3.11.0": {
            "map": {
                "browserify-cipher": "npm:browserify-cipher@1.0.0",
                "browserify-sign": "npm:browserify-sign@4.0.0",
                "create-ecdh": "npm:create-ecdh@4.0.0",
                "create-hash": "npm:create-hash@1.1.2",
                "create-hmac": "npm:create-hmac@1.1.4",
                "diffie-hellman": "npm:diffie-hellman@5.0.2",
                "inherits": "npm:inherits@2.0.1",
                "pbkdf2": "npm:pbkdf2@3.0.4",
                "public-encrypt": "npm:public-encrypt@4.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:des.js@1.0.0": {
            "map": {
                "inherits": "npm:inherits@2.0.1",
                "minimalistic-assert": "npm:minimalistic-assert@1.0.0"
            }
        },
        "npm:diffie-hellman@5.0.2": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "miller-rabin": "npm:miller-rabin@4.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:evp_bytestokey@1.0.0": {
            "map": {
                "create-hash": "npm:create-hash@1.1.2"
            }
        },
        "npm:hash.js@1.0.3": {
            "map": {
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:miller-rabin@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "brorand": "npm:brorand@1.0.5"
            }
        },
        "npm:parse-asn1@5.0.0": {
            "map": {
                "asn1.js": "npm:asn1.js@4.6.2",
                "browserify-aes": "npm:browserify-aes@1.0.6",
                "create-hash": "npm:create-hash@1.1.2",
                "evp_bytestokey": "npm:evp_bytestokey@1.0.0",
                "pbkdf2": "npm:pbkdf2@3.0.4"
            }
        },
        "npm:pbkdf2@3.0.4": {
            "map": {
                "create-hmac": "npm:create-hmac@1.1.4"
            }
        },
        "npm:public-encrypt@4.0.0": {
            "map": {
                "bn.js": "npm:bn.js@4.11.4",
                "browserify-rsa": "npm:browserify-rsa@4.0.1",
                "create-hash": "npm:create-hash@1.1.2",
                "parse-asn1": "npm:parse-asn1@5.0.0",
                "randombytes": "npm:randombytes@2.0.3"
            }
        },
        "npm:sha.js@2.4.5": {
            "map": {
                "inherits": "npm:inherits@2.0.1"
            }
        },
        "npm:stream-browserify@2.0.1": {
            "map": {
                "inherits": "npm:inherits@2.0.1",
                "readable-stream": "npm:readable-stream@2.1.4"
            }
        },
        "npm:supports-color@3.1.2": {
            "map": {
                "has-flag": "npm:has-flag@1.0.0"
            }
        },
        "github:mobilexag/plugin-sass@0.4.6": {
            "map": {
                "fs": "npm:jspm-nodelibs-fs@0.2.0",
                "path": "npm:jspm-nodelibs-path@0.2.0",
                "url": "npm:jspm-nodelibs-url@0.2.0",
                "autoprefixer": "npm:autoprefixer@6.3.6",
                "lodash": "npm:lodash@4.13.1",
                "postcss": "npm:postcss@5.0.21",
                "sass.js": "npm:sass.js@0.9.10",
                "reqwest": "github:ded/reqwest@2.0.5"
            }
        },
        "npm:postcss@5.0.21": {
            "map": {
                "source-map": "npm:source-map@0.5.6",
                "supports-color": "npm:supports-color@3.1.2",
                "js-base64": "npm:js-base64@2.1.9"
            }
        },
        "npm:browserslist@1.3.4": {
            "map": {
                "caniuse-db": "npm:caniuse-db@1.0.30000488"
            }
        },
        "npm:readable-stream@2.1.4": {
            "map": {
                "inherits": "npm:inherits@2.0.1",
                "isarray": "npm:isarray@1.0.0",
                "string_decoder": "npm:string_decoder@0.10.31",
                "process-nextick-args": "npm:process-nextick-args@1.0.7",
                "util-deprecate": "npm:util-deprecate@1.0.2",
                "buffer-shims": "npm:buffer-shims@1.0.0",
                "core-util-is": "npm:core-util-is@1.0.2"
            }
        },
        "npm:elliptic@6.3.1": {
            "map": {
                "inherits": "npm:inherits@2.0.1",
                "bn.js": "npm:bn.js@4.11.4",
                "brorand": "npm:brorand@1.0.5",
                "hash.js": "npm:hash.js@1.0.3"
            }
        },
        "npm:asn1.js@4.6.2": {
            "map": {
                "inherits": "npm:inherits@2.0.1",
                "bn.js": "npm:bn.js@4.11.4",
                "minimalistic-assert": "npm:minimalistic-assert@1.0.0"
            }
        },
        "npm:buffer@4.7.0": {
            "map": {
                "isarray": "npm:isarray@1.0.0",
                "ieee754": "npm:ieee754@1.1.6",
                "base64-js": "npm:base64-js@1.1.2"
            }
        },
        "npm:url@0.11.0": {
            "map": {
                "punycode": "npm:punycode@1.3.2",
                "querystring": "npm:querystring@0.2.0"
            }
        },
        "npm:jspm-nodelibs-url@0.2.0": {
            "map": {
                "url-browserify": "npm:url@0.11.0"
            }
        },
        "github:jspm/nodelibs-crypto@0.2.0-alpha": {
            "map": {
                "crypto-browserify": "npm:crypto-browserify@3.11.0"
            }
        },
        "github:jspm/nodelibs-buffer@0.2.0-alpha": {
            "map": {
                "buffer-browserify": "npm:buffer@4.7.0"
            }
        },
        "github:jspm/nodelibs-stream@0.2.0-alpha": {
            "map": {
                "stream-browserify": "npm:stream-browserify@2.0.1"
            }
        }
    }
});
